import { render, staticRenderFns } from "./MyHelloWorld.vue?vue&type=template&id=43a55f15"
import script from "./MyHelloWorld.vue?vue&type=script&lang=js"
export * from "./MyHelloWorld.vue?vue&type=script&lang=js"
import style0 from "./MyHelloWorld.vue?vue&type=style&index=0&id=43a55f15&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports